module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.6 155.1"><path class="st0" d="M52.3 155.1V84.4H76l3.6-27.6H52.3V39.2c0-8 2.2-13.4 13.7-13.4h14.6V1.1C78 .8 69.4 0 59.3 0 38.2 0 23.8 12.9 23.8 36.5v20.3H0v27.6h23.8v70.8h28.5z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fb.svg
// module id = 21
// module chunks = 0